export default "__VITE_ASSET__BdP4K6i1__"